import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { PROJECT_DETAILS } from './actions';
import { RECOMMENDED_CARRIERS, PROJECT_GROUPS, PROJECT_CARRIER_MAP } from './actions/';

export const reducers = createReducer(
	initialState,
	on(PROJECT_DETAILS.PROJECT.GET, (state) => ({
		...state,
		loadingProject: true,
	})),
	on(PROJECT_DETAILS.PROJECT.SUCCESS, (state, action) => ({
		...state,
		loadingProject: false,
		projectDTO: action.projectDTO,
	})),

	on(PROJECT_DETAILS.PROJECT.GET_ALL, (state) => ({
		...state,
		isLoadingProjectsList: true,
	})),
	on(PROJECT_DETAILS.PROJECT.SET_ALL_PROJECTS_LIST, (state, action) => ({
		...state,
		allProjectsList: action.list,
	})),
	on(PROJECT_DETAILS.PROJECT.SET_CARRIERS_PROJECTS_LIST, (state, action) => ({
		...state,
		carriersProjectsList: action.list,
	})),
	on(PROJECT_DETAILS.PROJECT.SET_PROJECTS_NEXT_PAGE, (state, action) => ({
		...state,
		projectsNextPage: action.projectsNextPage,
	})),
	on(PROJECT_DETAILS.PROJECT.SET_PROJECTS_PAGE, (state, action) => ({
		...state,
		projectsPage: action.page,
	})),
	on(PROJECT_DETAILS.PROJECT.SET_TOTAL_PROJECTS, (state, action) => ({
		...state,
		totalNumberOfProjects: action.totalElements,
	})),
	on(PROJECT_DETAILS.PROJECT.GET_ALL_SUCCESS, (state) => ({
		...state,
		isLoadingProjectsList: false,
	})),

	on(PROJECT_DETAILS.PROJECT.SET_ID, (state, action) => ({
		...state,
		projectId: action.projectId,
	})),
	on(PROJECT_DETAILS.PROJECT.SET_CAPACITY_SEARCH_FORM, (state, action) => ({
		...state,
		searchTruckForm: action.searchTruckForm,
	})),
	on(PROJECT_DETAILS.ENGAGED_CARRIER_IDS.SET, (state, action) => ({
		...state,
		engagedCarrierIds: action.carrierIds,
	})),
	on(PROJECT_DETAILS.SET.USERS_LIST, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),
	on(PROJECT_DETAILS.SET.CUSTOMER_ONLY_PROJECT, (state, action) => ({
		...state,
		customerOnlyProject: action.customerOnlyProject,
	})),

	// recommended carriers reducers
	on(RECOMMENDED_CARRIERS.SEARCH_LANES, (state) => ({
		...state,
		loadingLanesList: true,
	})),
	on(RECOMMENDED_CARRIERS.SEARCH_LANES_SUCCESS, (state) => ({
		...state,
		loadingLanesList: false,
	})),
	on(RECOMMENDED_CARRIERS.SEARCH_LANES_FAILURE, (state) => ({
		...state,
		loadingLanesList: false,
	})),
	on(RECOMMENDED_CARRIERS.SET.NUMBER_OF_LANES, (state, action) => ({
		...state,
		numberOfLanes: action.count,
	})),

	on(RECOMMENDED_CARRIERS.SET.USER_CARRIER.MAP, (state, action) => ({
		...state,
		userCarrierMap: action.userCarrierMap,
	})),
	on(RECOMMENDED_CARRIERS.SET.USER_CARRIER.LIST, (state, action) => ({
		...state,
		userCarrierMapList: action.list,
	})),
	on(RECOMMENDED_CARRIERS.SET.TRUCK_LANE_SEARCH_ID, (state, action) => ({
		...state,
		truckLaneSearchId: action.id,
	})),
	on(RECOMMENDED_CARRIERS.SET.ALL_CAPACITY_SEARCH_RESULT, (state, action) => ({
		...state,
		allCapacitySearchResults: action.list,
	})),
	on(RECOMMENDED_CARRIERS.SET.TRUCK_SEARCH_RESULT, (state, action) => ({
		...state,
		truckSearchResult: action.list,
	})),
	on(RECOMMENDED_CARRIERS.SET.CAPACITY_SEARCH_RESULT, (state, action) => ({
		...state,
		capacitySearchResults: action.list,
	})),

	on(RECOMMENDED_CARRIERS.CAPACITY_SEARCH.DOWNLOAD_CSV, (state, action) => ({
		...state,
		capacitySearchCsvDownloadInProgress: true,
	})),
	on(RECOMMENDED_CARRIERS.CAPACITY_SEARCH.DOWNLOAD_COMPLETE, (state, action) => ({
		...state,
		capacitySearchCsvDownloadInProgress: false,
	})),
	on(RECOMMENDED_CARRIERS.SET.BEST_MATCH, (state, action) => ({
		...state,
		bestMatch: action.bestMatch,
	})),
	on(RECOMMENDED_CARRIERS.SET.CARRIER_SEARCH, (state, action) => ({
		...state,
		originDeadhead: action.originDeadhead,
		destinationDeadhead: action.destinationDeadhead,
		powerUnits: action.powerUnits,
		minLoadsPerWeek: action.minLoadsPerWeek,
		ratesOnly: action.ratesOnly,
		carrierMc: action.mc,
		carrierDot: action.dot,
		carrierBusinessName: action.businessName,
		carrierHQ: action.carrierHQ,
		myCarriers: action.myCarriers,
		outOfNetworkCarriers: action.outOfNetworkCarriers,
		carrierSearchString: action.carrierSearchString,
	})),
	on(RECOMMENDED_CARRIERS.SET.MATCHED_CARRIER_HQ_IDS, (state, action) => ({
		...state,
		matchedCarrierHqIds: action.carrierIds,
	})),

	// project groups reducers
	on(PROJECT_GROUPS.SET.PROJECT_GROUPS, (state, action) => ({
		...state,
		projectGroups: action.list,
	})),
	on(PROJECT_GROUPS.MOVE_GROUPS_SUCCESS, (state, action) => ({
		...state,
	})),

	// project carrier maps reducers
	on(PROJECT_CARRIER_MAP.SET.ENGAGED_CARRIERS_COUNT, (state, action) => ({
		...state,
		engagedCarriersCount: action.total,
	})),
	on(PROJECT_CARRIER_MAP.SET.PROCURED_CARRIERS_COUNT, (state, action) => ({
		...state,
		procuredCarriersCount: action.total,
	})),
	on(PROJECT_CARRIER_MAP.SET.PROCURED_CARRIERS_WITHOUT_COUNT, (state, action) => ({
		...state,
		procuredCarriersWithoutGroupCount: action.total,
	})),

	on(PROJECT_CARRIER_MAP.SET.ENGAGED_CARRIERS_LIST, (state, action) => ({
		...state,
		engagedCarriersList: action.list,
	})),
	on(PROJECT_CARRIER_MAP.SET.PROCURED_CARRIERS_LIST, (state, action) => ({
		...state,
		procuredCarriersList: action.list,
	})),
	on(PROJECT_CARRIER_MAP.SET.ALL_PROJECT_CARRIER_MAPS_LIST, (state, action) => ({
		...state,
		allProjectCarrierMapsList: action.list,
	})),
	on(PROJECT_CARRIER_MAP.SET.CONTACT_UPDATE, (state, action) => ({
		...state,
		allProjectCarrierMapsList: state.allProjectCarrierMapsList.map((pcm) => {
			if (pcm.id === action.projectCarrierMap.id) {
				return action.projectCarrierMap;
			}
			return pcm;
		}),
		procuredCarriersList: state.procuredCarriersList.map((pcm) => {
			if (pcm.id === action.projectCarrierMap.id) {
				return action.projectCarrierMap;
			}
			return pcm;
		}),
	})),

	on(PROJECT_CARRIER_MAP.GET_ALL, (state) => ({
		...state,
		loadingProjectCarrierMaps: true,
	})),
	on(PROJECT_CARRIER_MAP.GET_ALL_SUCCESS, (state) => ({
		...state,
		loadingProjectCarrierMaps: false,
	})),

	on(PROJECT_CARRIER_MAP.LANES.ACCOUNT_CARRIER.GET, (state) => ({
		...state,
		loadingAccountCarrierLanes: true,
	})),
	on(PROJECT_CARRIER_MAP.LANES.ACCOUNT_CARRIER.SUCCESS, (state, action) => ({
		...state,
		loadingAccountCarrierLanes: false,
		accountCarrierLanes: action.accountCarrierLanes,
	})),
	on(PROJECT_CARRIER_MAP.LANES.CARRIER.GET, (state) => ({
		...state,
		loadingAccountCarrierLanes: true,
	})),
	on(PROJECT_CARRIER_MAP.LANES.CARRIER.SUCCESS, (state, action) => ({
		...state,
		loadingAccountCarrierLanes: false,
		accountCarrierLanes: action.accountCarrierLanes,
	})),

	on(PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.DELETE, (state) => ({
		...state,
		removingEngagedCarriersInProgress: true,
	})),
	on(PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.SUCCESS, (state) => ({
		...state,
		removingEngagedCarriersInProgress: false,
	})),
	on(PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.FAILURE, (state) => ({
		...state,
		removingEngagedCarriersInProgress: false,
	})),

	on(PROJECT_DETAILS.RESET_STATE, (state) => ({
		...initialState,
	}))
);
